import { RequestConfig } from '@/interface'

const PRIFIX = '/adminMessage/'
const messageConfig: RequestConfig = {
  // 删除已读消息
  messageClear: {
    url: `${PRIFIX}clear`,
    method: 'post'
  },
  // 删除通知
  messageDeleteById: {
    url: `${PRIFIX}deleteById`, // /{messageId}
    method: 'post'
  },
  // deleteByLabel
  messageDeleteByLabel: {
    url: `${PRIFIX}deleteByLabel`,
    method: 'post'
  },
  // 下载错误模板
  messageDownImportError: {
    url: `${PRIFIX}downImportError`,
    method: 'post'
  },
  // getById
  messageGetById: {
    url: `${PRIFIX}getById`, // /{messageId}
    method: 'post'
  },
  // 查询导入信息
  messageQueryImportInfo: {
    url: `${PRIFIX}queryImportInfo`,
    method: 'post'
  },
  // 查询导入数量
  messageQueryImportNum: {
    url: `${PRIFIX}queryImportNum`,
    method: 'post'
  },
  // 查询消息列表
  messageQueryList: {
    url: `${PRIFIX}queryList`,
    method: 'post'
  },
  // 查询未读消息
  messageQueryUnreadCount: {
    url: `${PRIFIX}queryUnreadCount`,
    method: 'post'
  },
  // 全部标记为已读
  messageReadAllMessage: {
    url: `${PRIFIX}readAllMessage`,
    method: 'post'
  },
  // 单个标记为已读
  messageReadMessage: {
    url: `${PRIFIX}readMessage`,
    method: 'post'
  },
  // save
  messageSave: {
    url: `${PRIFIX}save`,
    method: 'post'
  },
  // saveOrUpdateMessage
  messageSaveOrUpdateMessage: {
    url: `${PRIFIX}saveOrUpdateMessage`,
    method: 'post'
  },
  // sendMessage
  messageSendMessage: {
    url: `${PRIFIX}sendMessage`,
    method: 'post'
  },
  // update
  messageUpdate: {
    url: `${PRIFIX}update`,
    method: 'post'
  }
}
export default messageConfig
